/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_MiscInputs */

const en_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miscellaneous`)
};

const es_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varios`)
};

const fr_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divers`)
};

const de_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const ja_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

const zh_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const ar_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متفرقات`)
};

const id_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lain-lain`)
};

const it_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varie`)
};

const ru_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разное`)
};

const pt_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diversos`)
};

const ko_listing_category_misc = /** @type {(inputs: Listing_Category_MiscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기타`)
};

/**
* | output |
* | --- |
* | "Miscellaneous" |
*
* @param {Listing_Category_MiscInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_misc = /** @type {((inputs?: Listing_Category_MiscInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_MiscInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_misc(inputs)
	if (locale === "es") return es_listing_category_misc(inputs)
	if (locale === "fr") return fr_listing_category_misc(inputs)
	if (locale === "de") return de_listing_category_misc(inputs)
	if (locale === "ja") return ja_listing_category_misc(inputs)
	if (locale === "zh") return zh_listing_category_misc(inputs)
	if (locale === "ar") return ar_listing_category_misc(inputs)
	if (locale === "id") return id_listing_category_misc(inputs)
	if (locale === "it") return it_listing_category_misc(inputs)
	if (locale === "ru") return ru_listing_category_misc(inputs)
	if (locale === "pt") return pt_listing_category_misc(inputs)
	return ko_listing_category_misc(inputs)
});